import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  inline-size: ${spacing(2)};
  block-size: ${spacing(2)};
  border-radius: 100%;
  background-color: ${cssTheme.colors.warmGray[350]};
  position: relative;
  transform: translate(-50%, -50%);

  &::after {
    content: '';
    display: block;
    inline-size: ${spacing(1.125)};
    block-size: ${spacing(1.125)};
    border-radius: 100%;
    background-color: #fff;
    position: absolute;
    inset: 50% 50%;
    transform: translate(-50%, -50%);
  }
`
